export const DEVICE_PLACEMENTS = ['in_suite', 'common_area', 'unspecified'] as const;
export type DevicePlacement = (typeof DEVICE_PLACEMENTS)[number];

const PLACEMENT_SET = new Set<string>(DEVICE_PLACEMENTS);

export function coerceDevicePlacement(raw: unknown): DevicePlacement {
  const v = String(raw ?? '').trim().toLowerCase();
  if (PLACEMENT_SET.has(v)) return v as DevicePlacement;
  return 'unspecified';
}

export function placementForFieldSection(categoryLabel: string): DevicePlacement | null {
  const cat = categoryLabel.trim().toLowerCase();
  if (/in[\s-]?suite/.test(cat)) return 'in_suite';
  if (/common\s*area/.test(cat)) return 'common_area';
  return null;
}

export function inferPlacementFromLocation(device: {
  zone?: string | null;
  installationLocation?: string | null;
}): DevicePlacement | undefined {
  const hay = `${device.zone || ''} ${device.installationLocation || ''}`.toLowerCase();
  if (/\b(suite|unit\s*#?|apt|apartment|dwelling|residential)\b/.test(hay)) return 'in_suite';
  if (/\b(common|corridor|hallway|lobby|stair|garage|mechanical|electrical|boiler|laundry)\b/.test(hay)) {
    return 'common_area';
  }
  return undefined;
}

export function resolveDevicePlacement(device: {
  placement?: string | null;
  zone?: string | null;
  installationLocation?: string | null;
}): DevicePlacement {
  const explicit = coerceDevicePlacement(device.placement);
  if (explicit !== 'unspecified') return explicit;
  return inferPlacementFromLocation(device) ?? 'unspecified';
}

export function deviceMatchesSectionPlacement(
  device: {
    placement?: string | null;
    zone?: string | null;
    installationLocation?: string | null;
  },
  sectionPlacement: DevicePlacement | null
): boolean {
  if (!sectionPlacement) return true;
  const resolved = resolveDevicePlacement(device);
  if (resolved === 'unspecified') return true;
  return resolved === sectionPlacement;
}
